import React from "react";
import { Link } from "react-router-dom";

function FooterSix() {
  return (
    <div>
      {/* Start Footer Area  */}
      <footer className="footer-area footer-style-one-wrapper bg-color-footer bg-image-none tmp-section-gap">
        <div className="container">
          <div className="footer-main footer-style-one mt--0">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to={"/"}>
                      <img
                        src="assets/images/logo/Vaishnav_White_Logo_200x200.png"
                        alt="logo"
                      />
                    </Link>
                  </div>
                  <p className="description">
                    V2V Business Network is dedicated to empowering
                    entrepreneurs, professionals, and businesses by fostering
                    connections, collaboration, and growth. Our platform offers
                    a space for networking, learning, and unlocking new
                    opportunities to help you succeed.
                  </p>
                  {/* <div className="day-time">
                        <div className="icon">
                        <i className="fa-solid fa-alarm-clock" />
                        </div>
                        <div className="content">
                        <div className="day">Sunday - Friday:</div>
                        <div className="time">9:00 AM – 8:00 PM</div>
                        </div>
                    </div> */}
                  {/* <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to={"#"}>
                        <i className="fa-brands fa-facebook-f" />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"}>
                        <i className="fa-brands fa-linkedin-in" />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"}>
                        <i className="fa-brands fa-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"}>
                        <i className="fa-brands fa-instagram" />
                      </Link>
                    </li>
                  </ul> */}
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h3 className="ft-title text-white">Quick Links </h3>
                  <ul className="ft-link">
                    {/* <li>
                      <Link to={"/"}>Home </Link>
                    </li>
                    <li>
                      <Link to={"/About"}>About Us </Link>
                    </li> */}
                    {/* <li>
                      <Link to={"/"}>Services</Link>
                    </li>
                    <li>
                      <Link to={"/"}>Events & Webinars</Link>
                    </li> */}
                    <li>
                      <Link to={"/Contact-us"}>Contact Us</Link>
                    </li>
                    <li>
                      <Link to={"/privacypolicy"}>Privacy Policy</Link>
                    </li>
                    <li>
                        <Link to={'/support'}>Support</Link>
                        </li>
                    <li>
                        <Link to={'/terms-conditions'}>Terms & Conditions</Link>
                        </li>
                    <li>
                        <Link to={'/cancellation-refund'}>Cancellation & Refund</Link>
                        </li>
                    <li>
                        <Link to={'/shipping-exchange'}>Shipping and Exchange</Link>
                        </li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-lg-2 col-md-6">
                    <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                    <h5 className="ft-title">Solutions</h5>
                    <ul className="ft-link">
                        <li>
                        <Link to={'#'}>Brand</Link>
                        </li>
                        <li>
                        <Link to={'#'}>Counter</Link>
                        </li>
                        <li>
                        <Link to={'#'}>Services</Link>
                        </li>
                        <li>
                        <Link to={'#'}>News</Link>
                        </li>
                        <li>
                        <Link to={'#'}>Contact Us</Link>
                        </li>
                        <li>
                        <Link to={'/FaqOne'}>Support</Link>
                        </li>
                    </ul>
                    </div>
                </div> */}
              {/* <div className="col-lg-2 col-md-6">
                    <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                    <h5 className="ft-title">Address</h5>
                    <ul className="ft-link">
                        <li>
                        Email:  <a href="mailto:info@v2vbn.com">info@v2vbn.com</a> 
                        </li>
                        <li>
                        Phone:  <a href="mailto:info@v2vbn.com">info@v2vbn.com</a>  
                        </li>
                        <li>
                        Address<Link >Anandnagar Road, Satellite, Vrajdham Marg, Near Shyamal Char Rasta, Jodhpur Village, Ahmedabad, Gujarat 380015  </Link>
                        </li>
                        
                    </ul>
                    </div>
                </div> */}
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h3 className="ft-title text-white">Social Media </h3>
                  <ul className="ft-link">
                    <li>
                      <Link to={"https://www.facebook.com/100044332572954/photos/1182103149944093/?_rdr" } target="_blank"> 
                        <i
                          className="fa-brands fa-facebook-f"
                          style={{
                            paddingRight: "10px",
                          }}
                        />{" "}
                        Facebook
                      </Link>
                    </li>
                    {/* <li>
                      <Link to={"/"}>
                        <i
                          className="fa-brands fa-linkedin-in"
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        Linkedin
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to={"/"}>
                        <i
                          className="fa-brands fa-twitter"
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        Twitter
                      </Link>
                    </li> */}
                    <li>
                      <Link to={"https://www.instagram.com/yadunathjimahoday/?hl=en"} target="_blank">
                        <i
                          className="fa-brands fa-instagram"
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        Instagram
                      </Link>
                    </li>
                    {/* <li>
                        <Link to={'/Contact'}>Contact Us</Link>
                        </li>
                        <li>
                        <Link to={'/FaqOne'}>Support</Link>
                        </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h3 className="ft-title text-white">Address</h3>
                  <ul className="ft-link">
                    <li>
                      Email:{" "}
                      <a href="mailto:admin@v2vbn.org">admin@v2vbn.org</a>
                    </li>
                    <li>
                      Phone: <br />{" "}
                      <a href="telto:+919322687878">
                        {" "}
                        MINESH AMRUTLAL PATEL <br />
                        +91 93226 87878
                      </a>{" "}
                      <br />
                      <a href="telto:+919375627103">
                        {" "}
                        Ritesh Upadhyay <br />
                        +91 93756 27103
                      </a>{" "}
                      <br />
                      <a href="telto:+919924869699">
                        {" "}
                        Jimmy Shah <br />
                        +91 99248 69699
                      </a>{" "}
                      <br />
                    </li>
                    <li>
                      Address :{" "}
                      <Link>
                        Anandnagar Road, Satellite, Vrajdham Marg, Near Shyamal
                        Char Rasta, Jodhpur Village, Ahmedabad, Gujarat 380015{" "}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area-one bg-colorsame">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper ">
                <ul className="d-flex justify-content-center align-items-center gap-4">
                  <li className="text-white">
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#fff",
                      }}
                    >
                      CIN-
                    </span>{" "}
                    U94110GJ2025NPL160302
                  </li>
                  <li className="text-white">
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#fff",
                      }}
                    >
                      PAN-
                    </span>{" "}
                    AAKCV8573G
                  </li>
                  <li className="text-white">
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#fff",
                      }}
                    >
                      TAN-
                    </span>{" "}
                    AHMV14015B
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-area-one bg-colorsame">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © 2025 V2V Business Network. All Rights Reserved. Developed by{" "}
                  <Link to="https://www.veravalonline.com/" target="_blank">
                    VO
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Footer Area  */}
    </div>
  );
}

export default FooterSix;
